import Flex from './Flex';
import { SIZE } from './constants';

export default Flex;
export { SIZE };